
import React, { useState, useEffect } from 'react';
import { fetchReferrals } from './referrals.js';
import axios from "axios";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input/input';
import './App.css';
import Logo from './img/logo_white.png';
import Hero from './img/referrals.webp';
import feture1img from './img/savings.svg';
import feture2img from './img/profile.svg';
import feture3img from './img/app_Image.svg';
import fscs from './img/fscs.png';

// Main App funtional component.
function App() {
  //state variables.
  const [value, setValue] = useState('');
  const [apidata, setApiData] = useState([]);
  const [refCode, setRefCode] = useState("");
  const [referralsContent, setReferralsContent] = useState(null);

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // const values in page.
  const referralConst = {
    marketingURL: "https://www.monument.co",
    appStoreURL: "https://apps.apple.com/gb/app/monument-bank/id1556211953",
    playStoreURL: "https://play.google.com/store/apps/details?id=co.monument.app",
    errorpageMsg: "Internal error occured. Please try after some time.",
    fscs: "https://www.monument.co/fscs",
    privacyNotice: "https://www.monument.co/privacy",
    Trustpilot: "https://uk.trustpilot.com/review/www.monument.co",
    api_Server : process.env.REACT_APP_API_SERVER_URL,
    referralTerms: "https://cdn.prod.website-files.com/6435124ea79f72c265f72807/68af0a8a8a888dc90b2c8fb8_Referral%20Offer%20Terms%20M566_01_2508.pdf"
  }
  const getServer = () => {
    return window.location.hostname === "localhost"
      ? referralConst.api_Server
      : referralConst.api_Server || process.env.REACT_APP_API_SERVER_URL;
  }
  const refApi =
  getServer() + "/referrals/canRefer"
  //navigation function.
  const osfunction = () => {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Redirect to App Store for iOS devices
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href = 'https://apps.apple.com/gb/app/monument-bank/id1556211953';
    }
    // Redirect to Play Store for Android devices
    else if (/android/i.test(userAgent)) {
      window.location.href = 'https://play.google.com/store/apps/details?id=co.monument.app';
    }
    // Fallback for desktop or non-recognized mobile devices
    else {
      window.location.href = 'https://web.monument.co/app'; // Replace with the URL you wish to redirect to
    }
  }

  // Submit button function.
  const handleSubmit = async(e) => {
    e.preventDefault();

    let newErrors = validateForm(value|| '');
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Form submission logic here
      setIsSubmitting(true);

      axios
      .post(refApi,{
        "referralCode":refCode,
        "mobileNumber":value,
      }, {
        headers: { "access-control-allow-origin" : "*",
                   "Content-Type": "application/json" },
      })
      .then((response) => {
        setApiData(response);
        setSuccess(true);
        console.log(apidata);
      }).catch(error => {
        setErrors ({phonenumber:"We couldn’t process your request. Please try again."
        });
        setSuccess(false);
     })
     .finally(() => {
        setIsSubmitting(false);
     });
    } else {
      setSuccess(false);
      setIsSubmitting(false);
      console.log('Form submission failed due to validation errors.');
    }
  };

  //Download button function.
  const handleDownloadSubmit = (e) => {
    e.preventDefault();
    osfunction();
  };
  
  //Phone number and error validation function.
  const validateForm = (data) => {
    const errors = {};

    if (!data && !data.trim()) {
      errors.phonenumber = 'UK phone number is required';
    } else if (data.length > 0) {
      const pattern = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?(\d{4}|\d{3}))?$/;
      // Return true if the phone number
      // matched the Regex
      if (pattern.test(data)) {
        console.log('Form submission Success.');
      } else {
        errors.phonenumber = 'Please enter a valid UK phone number';
      }
    } 
    return errors;
  };

  useEffect(() => {
    let currentRefCode = (window.location.pathname.split("/").length > 1) ? window.location.pathname.split("/")[1]:"";
    console.log(currentRefCode);
    setRefCode(currentRefCode);

    const loadReferralsContent = async () => {
      const content = await fetchReferrals();
      if (content?.fields?.subtitle) {
        console.log('Premium content:', content.fields.subtitle);
        setReferralsContent(content.fields.subtitle + ".");
      } else {
        console.log('Failed to fetch offer end date from Contentful.');
      }
    };

    loadReferralsContent();
  },[]);
  return (
    <div className="main-container">
      <div className='left-container'>
        <div className='header'>
          <a href={referralConst.marketingURL} rel="noreferrer">
            <img
              className="monumentLogo"
              src={Logo}
              alt="brand logo"
            />
          </a>
        </div>
        {/* Success and failure case after Api call */}
        {success ? 
        <div className='form-container'>
          <div className='form-left '>
            <div className='hero'>
              <img
                className="monumentLogo"
                src={Hero}
                alt="brand logo"
              />
            </div>
            <div className='heading'>
            Download the Monument app to get started
            </div>
            <div className='heading-text'>Join Monument using the same mobile number ({value.replace('+44', '0')}) so we can track your referral.</div>
            <form onSubmit={handleDownloadSubmit}>
              <div className="row">
                <div className="submit">
                  <input type="submit" value="Download the app" />
                </div>
              </div>

            </form>
            <div className='referral-info'>
              <div>
              Meet our account eligibility criteria to claim your reward. You can track your progress in the Monument app.
              </div>

            </div>

          </div>

        </div>:
        <div className='form-container'>
          <div className='form-left '>
            <div className='hero'>
              <img
                className="monumentLogo"
                src={Hero}
                alt="brand logo"
              />
            </div>
            <div className='heading'>You’ve been invited to join Monument Bank</div>
            <div className='heading-text'>How to claim your £30 referral offer:</div>

            <ol className='referral-info'>
              <li>Enter your phone number below.</li>
              <li>Open a Monument savings account.</li>
              <li>Deposit at least £10,000 in a Cash ISA, or £25,000 across all savings accounts before the offer ends.</li>
              <li>£30 will be paid to your and your friend’s Linked Account.</li>
            </ol>

            <div className='heading-text'>{referralsContent}</div>

            <div className='referral-subtext'>By participating in the Referral Offer, you confirm that you have read and accepted the <a href={referralConst.referralTerms} target="_blank" rel="noreferrer">Referral Terms</a>. To find out more about how we use data then see our <a href={referralConst.privacyNotice} target="_blank" rel="noreferrer">privacy notice.</a></div>

            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="mobile-number-text">
                  <label htmlFor="phonenumber">Enter your phone number to begin</label>
                </div>
                <div className="col-265 mobile-number">
                    <PhoneInput
                      placeholder="07901 234 567"
                      country="GB"
                      id="phonenumber"
                      name="phonenumber"
                      value={value}
                      onChange={setValue}/>
                </div>
                <div className="submit">
                  <button
                    type="submit"
                    className={isSubmitting ? 'is-loading' : ''}
                    disabled={isSubmitting}
                  >
                    <span className="button-text">Accept Invite</span>
                    <span className="spinner" aria-hidden="true"></span>
                  </button>
                </div>
                {errors.phonenumber && (
                  <span className="error-message">
                     {errors.phonenumber}
                  </span>
                )}
              </div>

            </form>
            <div className='referral-subtext'>
              <div>
                We’ll use your phone number to track your referral. Your first name, first initial of your surname and referral status will be shared with the person who referred you. 
                <br />
                <br />
                If you’ve previously had a Monument savings account, you’re not eligible for the referral offer.
              </div>
            </div>
          </div>
        </div>}
      </div>
      <div className='right-container'>
        <div className='form-container'>
          <div className='form-right'>
            <div className='heading'>
              Over 85,000 clients and a service that feels personal
            </div>
            <div className='feature-1'>
              <div className='feature-1-img'>
                <img
                  className="fetureLogo"
                  src={feture1img}
                  alt="brand logo"
                />
              </div>
              <hr />
              <div className='feature-1-heading'>Savings shaped around you</div>
              <div className='feature-1-text'>From fixed to flexible, our accounts help you make more of your money for the goals that matter.</div>

            </div>
            <div className='feature-1'>
              <div className='feature-1-img'>
                <img
                  className="fetureLogo"
                  src={feture2img}
                  alt="brand logo"
                />
              </div>
              <hr />
              <div className='feature-1-heading'>Personal support, every time</div>
              <div className='feature-1-text'>Real support and clear answers, when you need them.</div>

            </div>
            <div className='feature-1'>
              <div className='feature-1-img'>
                <img
                  className="fetureLogo"
                  src={feture3img}
                  alt="brand logo"
                />
              </div>
              <hr />
              <div className='feature-1-heading'>An effortless app experience </div>
              <div className='feature-1-text'>Open your account in minutes and manage your savings with ease.
                <br/>
                <br/>
                All in one clear, intuitive app.
              </div>

            </div>
            <div className='rating'>
              <span className='rating-fscs'>
                <a href={referralConst.fscs} target="_blank" rel="noreferrer">
                  <img
                    className="fscsLogo"
                    src={fscs}
                    alt="fscs logo"
                  />
                </a>
              </span>
              <span>
                {/* <a href={referralConst.Trustpilot} target="_blank" rel="noreferrer">
                <img
                  className="ratingLogo"
                  src={rating}
                  alt="rating logo"
                />
              </a> */}
                {/* <!-- TrustBox widget - Mini --> */}
                <div className="trustpilot-widget rating-star" data-locale="en-GB" data-template-id="53aa8807dec7e10d38f59f32" data-businessunit-id="617ac96c5e43cf3543ffbde4" data-style-height="120px" data-style-width="100%" data-theme="light" data-text-color="#232323">
                  <a href={referralConst.Trustpilot} target="_blank" rel="noopener noreferrer">Trustpilot</a>
                </div>
                {/* <!-- End TrustBox widget --> */}
              </span>

            </div>

          </div>

        </div>
      </div>


    </div>
  );
}

export default App;